module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "space"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("First published in Great Britain in 2015 by"), _c('br'), _vm._v("\nPen & Sword Transport"), _c('br'), _vm._v("\nAn imprint of"), _c('br'), _vm._v("\nPen & Sword Books Ltd"), _c('br'), _vm._v("\n47 Church Street"), _c('br'), _vm._v("\nBarnsley"), _c('br'), _vm._v("\nSouth Yorkshire"), _c('br'), _vm._v("\nS70 2AS")])]), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Copyright © Keith Langston 2015")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("ISBN: 978 1 47382 356 3"), _c('br'), _vm._v("\nEPUB ISBN: 978 1 47385 186 3"), _c('br'), _vm._v("\nPRC ISBN: 978 1 47385 193 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("The right of Keith Langston to be identified as Author of this work has"), _c('br'), _vm._v("\nbeen asserted by him in accordance with the Copyright, Designs and Patents"), _c('br'), _vm._v("\nAct 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("A CIP catalogue record for this book is"), _c('br'), _vm._v("\navailable from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted"), _c('br'), _vm._v("\nin any form or by any means, electronic or mechanical including photocopying,"), _c('br'), _vm._v("\nrecording or by any information storage and retrieval system, without"), _c('br'), _vm._v("\npermission from the Publisher in writing.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Typeset in 11pt Minion by Mac Style Ltd, Bridlington, East Yorkshire"), _c('br'), _vm._v("\nPrinted and bound in India by Replika Press Pvt Ltd")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Pen & Sword Books Ltd incorporates the imprints of Pen & Sword Archaeology, Atlas,"), _c('br'), _vm._v("\nAviation, Battleground, Discovery, Family History, History, Maritime, Military, Naval,"), _c('br'), _vm._v("\nPolitics, Railways, Select, Transport, True Crime, and Fiction, Frontline Books, Leo"), _c('br'), _vm._v("\nCooper, Praetorian Press, Seaforth Publishing and Wharncliffe.")])]), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("For a complete list of Pen & Sword titles please contact"), _c('br'), _vm._v("\nPEN & SWORD BOOKS LIMITED"), _c('br'), _vm._v("\n47 Church Street, Barnsley, South Yorkshire, S70 2AS, England"), _c('br'), _vm._v("\nE-mail: ")]), _c('a', {
    attrs: {
      "href": "mailto:enquiries@pen-and-sword.co.uk"
    }
  }, [_vm._v("enquiries@pen-and-sword.co.uk")]), _c('br'), _vm._v("\nWebsite: "), _c('a', {
    attrs: {
      "href": "http://www.pen-and-sword.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.pen-and-sword.co.uk")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e620bc9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 60
// module chunks = 0